/* 🤖 this file was generated by svg-to-ts */
export const iconDefiwallet: {
  name: 'defiwallet';
  data: string;
} = {
  name: 'defiwallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M20.89 7.85h-9.8l-1.15 4.99h12.13zm-5.86 13.96-2.2-2.09V16.4l-2.89-1.84L6.64 17l4.47 7.78h1.8l2.12-1.97z"/><path fill="currentColor" d="m18.12 16.4 1.05-2.79h-6.34l1.08 2.79-.33 3.12h4.84z"/><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m0 30.36L3.55 23.18V8.82L16 1.64l12.45 7.18v14.36z"/><path fill="currentColor" d="M19.22 16.4v3.32l-2.19 2.09v1l2.12 1.95h1.77L25.36 17l-3.27-2.47z"/></svg>`,
};
